import { cva } from '@/styled-system/css';

export const textAreaRecipe = cva({
  base: {
    paddingBlock: 'Textarea.padding.vert',
    borderRadius: 'obj.default',
    /* https://stackoverflow.com/questions/7144843/extra-space-under-textarea-differs-along-browsers */
    verticalAlign: 'top',
  },
  variants: {
    readOnly: {
      true: { paddingInline: 'none' },
      false: { paddingInline: 'default' },
    },
  },
});
